import { createBreakpoints } from '@chakra-ui/theme-tools'

export const BREAKPOINTS = createBreakpoints({
  sm: '480px',
  md: '768px',
  lg: '1110px',
  xl: '1280px',
  '2xl': '1536px',
});